export default {
      id: "implantation_developpement-usage",
      viewBox: "0 0 70 70",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#implantation_developpement-usage",
      toString: function () {
        return this.url;
      }
    }